import React from 'react';
import { Halo, RuleDot } from './Decor';
export function Problem() {
  return <section aria-labelledby="problema-titulo" className="relative overflow-hidden bg-lavender-50" data-id="element-200" data-mp="2pf8pw8d587n0">
      <Halo soft className="-left-32 top-0 h-[22rem] w-[22rem]" data-id="element-201" data-mp="2bfzle5yav1yv" />

      <div className="relative mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-16 lg:py-20" data-id="element-202" data-mp="2bhtw6rfuxdp8">
        <div className="grid gap-6 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-end lg:gap-16" data-id="element-203" data-mp="2gczhpp5ckqcs">
          <div data-id="element-204" data-mp="21ntl88xw9e8l">
            <RuleDot data-id="element-205" data-mp="26gmmuny2g6gg" />
            <h2 id="problema-titulo" className="mt-5 font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.5rem]" data-id="element-206" data-mp="26h692gur1h0a">
              Empezar un negocio puede sentirse complicado.
              <span className="block text-plum-500" data-id="element-207" data-mp="1wr34dje9mem4">No tiene que serlo.</span>
            </h2>
          </div>

          <div data-id="element-208" data-mp="1it54fj0oykq5">
            <p className="max-w-xl text-[1rem] leading-relaxed text-muted sm:text-[1.0625rem]" data-id="element-209" data-mp="1itelui7o7jk8">
              LLC, EIN, identidad, web… cuando estás empezando puede ser difícil saber qué
              necesitas realmente y qué deberías hacer primero.
            </p>
            <p className="mt-5 max-w-lg font-display text-[1.15rem] leading-snug text-plum-800 sm:mt-6 sm:text-2xl" data-id="element-210" data-mp="oac2esqnbtoj">
              En Inkova te ayudamos a poner cada pieza en el orden correcto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}